import BaseViz from './BaseViz'
import PieChartChart from '../charts/PieChartChart'
import PieDataController from '../viz_behaviors/PieDataController'
export default class PieChartViz extends BaseViz {
  static chartClass = PieChartChart
  static dataControllerClass = PieDataController
  static defaultConfig = {
    LegendBehavior:{
      showLegend: {
        value: false,
      }
    },
    ItemsHelper: {
      colorScale: {
        value: 'categorical',
        options: ['categorical'],
        nonEditable: true
      },
    },
    valueFormat: {
      type: [String,Array,Function,null],
      default: null
    },
    unit: {
      type: [String,Boolean,null],
      default: false
    },
  }
}
